import { IconButton, Tooltip } from '@mui/material'
import { useRegistryContext } from 'context/RegistryContext';
import DeleteIcon from 'icons/DeleteIcon'
import ViewIcon from 'icons/ViewIcon';
import { useNavigate } from 'react-router-dom';
import { colors } from 'styles/colors';

interface Props {
  id: number;
  refetch?: () => void;
}

export default function ViewRegistryPatientActionButton({ id }: Props) {
  const { registry } = useRegistryContext();
  const navigate = useNavigate();

  const handlePress = () => {
    navigate(`patients/${id}`);
  };

  return (
    <Tooltip title={'View'}>
      <IconButton
        onClick={handlePress}
        sx={{
          width: 25,
          height: 25,
          backgroundColor: colors.view,
          borderRadius: '4px',
          padding: 0,
          '&:hover': {
            backgroundColor: colors.view,
          },
        }}
      >
        <ViewIcon size={12} color='white' />
      </IconButton>
    </Tooltip>
  )
}
